<sl-form-view [mainPageActions]="currentActions">
    @if (!!recordSummary()) {
        <mat-card>
            <mat-card-content class="container ml-0">
                <div class="row">
                    <div class="col-xl-4 col-lg-6 col-md-12 mb-3">
                        <h2 class="summary">{{ 'Address.Title' | translate }}</h2>
                        <p class="formatted-address">{{ recordSummary()!.formattedAddress }}</p>
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-12 mb-3">
                        <h2 class="summary">{{ 'Traders.Payment' | translate }}</h2>
                        <div class="row">
                            <div class="col-md-4">
                                <label class="font-weight-light">{{ 'Traders.PaymentType' | translate }}</label>
                            </div>
                            <div class="col-md-8">
                                <span>{{ recordSummary()!.paymentTypeDescription }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <label class="font-weight-light">{{ 'Traders.BpId' | translate }}</label>
                            </div>
                            <div class="col-md-8">
                                <span>{{ recordSummary()!.bpId }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <label class="font-weight-light">{{ 'Traders.PaymentIban' | translate }}</label>
                            </div>
                            <div class="col-md-8">
                                <span>{{ recordSummary()!.paymentIBAN ? recordSummary()!.paymentIBAN : '-' }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-12 mb-3">
                        <h2 class="summary">{{ 'General.OtherInformation' | translate }}</h2>
                        <div class="row">
                            <div class="col-md-4">
                                <label class="font-weight-light">{{ 'General.Language' | translate }}</label>
                            </div>
                            <div class="col-md-8">
                                <span>{{ recordSummary()!.languageName }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <label class="font-weight-light">{{ 'Traders.HasAregData' | translate }}</label>
                            </div>
                            <div class="col-md-8">
                                <span>{{ recordSummary()!.hasAregData ? ('General.Yes' | translate) : ('General.No' | translate) }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <label class="font-weight-light">
                                    {{ 'Shareholders.DividendRight' | translate }}
                                </label>
                            </div>
                            <div class="col-md-8">
                                <span>{{ recordSummary()!.dividendRight ? ('General.Yes' | translate) : ('General.No' | translate) }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <h2 class="summary">{{ 'ShareStatistics.SharesBalance' | translate }}</h2>
                        <sl-share-info class="col-12" [id]="recordId()!" [type]="ShareInfoTypeEnum.Trader" />
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    }
</sl-form-view>
